var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" /test/reference_model "),_c('br'),_vm._v(" "),(!!_vm.proxyEdit)?_c('span',[_vm._v(_vm._s(_vm.proxyEdit.product))]):_vm._e(),_c('v-btn',{on:{"click":_vm.onChange}},[_vm._v("Change ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }